import { gql } from '@apollo/client';

export const UPDATE_USER = gql`
  mutation UpdateUser(
    $id: Int!
    $userUpdateInput: UserUpdateInput!
    $isSupportUser: Boolean
    $file: Upload
  ) {
    updateUser(id: $id, userUpdateInput: $userUpdateInput, file: $file, isSupportUser: $isSupportUser) {
      id
    }
  }
`;
